import { render, staticRenderFns } from "./avalonMenuStylesEditTheme.vue?vue&type=template&id=be05b7b4&scoped=true&"
import script from "./avalonMenuStylesEditTheme.vue?vue&type=script&lang=js&"
export * from "./avalonMenuStylesEditTheme.vue?vue&type=script&lang=js&"
import style0 from "./avalonMenuStylesEditTheme.vue?vue&type=style&index=0&id=be05b7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be05b7b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VColorPicker,VDivider,VExpandTransition,VHover,VIcon,VSheet})
